import React from 'react';
import { Badge } from 'antd';
import ColorHash from 'color-hash';

const colorHash = new ColorHash();

export default function CropNameBadge({ name }) {
  if (!name || name === '-') {
    return name || '-';
  }
  const color = colorHash.hex(name);
  return <Badge color={color} text={name} />;
}
